<template>
  <v-menu v-model="isOpen" left offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card class="pa-2">
      <OTextField label="Delta S" v-model="deltaS" />
      <div class="d-flex">
        <v-btn icon @click="dismiss"><v-icon>mdi-close</v-icon></v-btn>
        <v-btn icon @click="apply"><v-icon>mdi-check</v-icon></v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  data() {
    return { isOpen: false, deltaS: 0 }
  },
  methods: {
    dismiss() {
      this.isOpen = false
    },
    apply() {
      let value = this.deltaS
      this.deltaS = 0
      this.isOpen = false
      this.$emit('input', value)
    }
  }
}
</script>

<style></style>
